import { render, staticRenderFns } from "./contacts-item.vue?vue&type=template&id=56d4d650&"
import script from "./contacts-item.vue?vue&type=script&lang=js&"
export * from "./contacts-item.vue?vue&type=script&lang=js&"
import style0 from "./contacts-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports